import {
  createGlobalStyle,
  ThemeProvider as SCThemeProvider,
} from 'styled-components';
import { darkTheme, lightTheme } from './theme';
import { useThemeMode } from './ThemeModeProvider';

const GlobalStyle = createGlobalStyle`
  html {
    background: ${({ theme }) => theme.paper.default};
  }
`;

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { mode } = useThemeMode();

  return (
    <SCThemeProvider
      theme={mode === 'light' ? lightTheme(mode) : darkTheme(mode)}
    >
      <GlobalStyle />
      {children}
    </SCThemeProvider>
  );
}
